module.exports = __webpack_public_path__ + "img/encinterativa-logo.61e848bb.png";